'use client';

import { ProgressButton } from './ProgressButton';
import { useFlowProgressButtonState } from './useFlowProgressButtonState';
import { useNavigation } from '../../hooks/useNavigation';

export const BackButton = ({ children }: { children: React.ReactNode }) => {
  const { onBack, canNavigateBack } = useNavigation();

  const buttonProps = useFlowProgressButtonState(onBack);

  if (!canNavigateBack) {
    return null;
  }

  return (
    <ProgressButton buttonType="text" {...buttonProps}>
      {children}
    </ProgressButton>
  );
};
